// A single "last copied" slot for the Questions copy/paste flows. Copying a
// single Question and copying a whole Task's Questions used to be two
// independent localStorage keys, so both could be "live" at once and both
// Paste buttons would show enabled regardless of which was copied more
// recently. Storing one typed record here means the newer copy always wins.
const CLIPBOARD_KEY = "modelTaskQuestionClipboard";

const TYPE_QUESTION = "question";
const TYPE_TASK_QUESTIONS = "taskQuestions";

const readClipboard = () => {
	try {
		const parsed = JSON.parse(localStorage.getItem(CLIPBOARD_KEY));
		const id = Number.parseInt(parsed?.id, 10);
		if (!Number.isInteger(id) || id <= 0) return null;
		if (parsed.type !== TYPE_QUESTION && parsed.type !== TYPE_TASK_QUESTIONS)
			return null;
		return { type: parsed.type, id };
	} catch {
		return null;
	}
};

const writeClipboard = (type, id) =>
	localStorage.setItem(CLIPBOARD_KEY, JSON.stringify({ type, id }));

export const setCopiedQuestionId = (questionId) =>
	writeClipboard(TYPE_QUESTION, questionId);

export const setCopiedQuestionsTaskId = (taskId) =>
	writeClipboard(TYPE_TASK_QUESTIONS, taskId);

export const getCopiedQuestionId = () => {
	const clipboard = readClipboard();
	return clipboard?.type === TYPE_QUESTION ? clipboard.id : null;
};

export const getCopiedQuestionsTaskId = () => {
	const clipboard = readClipboard();
	return clipboard?.type === TYPE_TASK_QUESTIONS ? clipboard.id : null;
};

export const clearCopiedQuestionsClipboard = () =>
	localStorage.removeItem(CLIPBOARD_KEY);

export { CLIPBOARD_KEY };
